
function _isIE () {
  let ua = window.navigator.userAgent // Check the userAgent property of the window.navigator object
  let msie = ua.indexOf('MSIE ') // IE 10 or older
  let trident = ua.indexOf('Trident/') // IE 11

  return (msie > 0 || trident > 0)
}

export const isIE = _isIE()



// WEBPACK FOOTER //
// ./src/utils/Platform.ts